export default "__VITE_ASSET__38ef6278__"